import { createContext, useContext, useEffect, useMemo, useState } from 'react';

export interface PageTab {
  label: string;
  id?: string;
}

export interface PageTabsState {
  tabs: PageTab[];
  activeTab: number;
  setTabs: (tabs: PageTab[]) => void;
  setActiveTab: (index: number) => void;
}

const noop = () => undefined;

const PageTabsContext = createContext<PageTabsState>({ tabs: [], activeTab: 0, setTabs: noop, setActiveTab: noop });

export const usePageTabsState = (): PageTabsState => {
  const [tabs, setTabs] = useState<PageTab[]>([]);
  const [activeTab, setActiveTab] = useState(0);

  return useMemo(() => ({ tabs, activeTab, setTabs, setActiveTab }), [tabs, activeTab]);
};

export const PageTabsProvider = PageTabsContext.Provider;

export const usePageTabsContext = (): PageTabsState => useContext(PageTabsContext);

export const usePageTabs = (tabs: PageTab[]): number => {
  const { setTabs, activeTab, setActiveTab } = usePageTabsContext();
  const key = JSON.stringify(tabs);

  useEffect(() => {
    setTabs(JSON.parse(key) as PageTab[]);
    setActiveTab(0);
    return () => setTabs([]);
  }, [key, setTabs, setActiveTab]);

  return activeTab;
};
